import { Mail } from "lucide-react";

import { Button } from "@/components/ui/button";
import { LEGAL_DPO_EMAIL } from "@/content/legal/legal-meta";

type LegalContactSectionProps = {
  documentTitle: string;
};

function LegalContactSection({ documentTitle }: LegalContactSectionProps) {
  const subject = encodeURIComponent(`[Innovally] Solicitação LGPD — ${documentTitle}`);
  const body = encodeURIComponent(
    "Olá,\n\nGostaria de exercer meus direitos previstos na LGPD.\n\nNome:\nE-mail:\nSolicitação:\n\n",
  );

  return (
    <section className="rounded-2xl border border-border bg-card p-6 sm:p-7">
      <div className="flex items-center gap-2">
        <Mail className="h-4.5 w-4.5 text-primary" />
        <h2 className="font-display text-lg font-semibold tracking-tight text-foreground">
          Encarregado de dados
        </h2>
      </div>
      <p className="mt-3 text-sm leading-7 text-muted-foreground">
        Para dúvidas sobre privacidade ou exercício de direitos previstos na LGPD, entre em contato
        com {LEGAL_DPO_EMAIL}.
      </p>
      <Button asChild variant="outline" size="sm" className="mt-4">
        <a href={`mailto:${LEGAL_DPO_EMAIL}?subject=${subject}&body=${body}`}>
          Falar com encarregado de dados
        </a>
      </Button>
    </section>
  );
}

export { LegalContactSection };
